module.exports = __webpack_public_path__ + "img/payment-success-tick.afad272c.svg";